import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type SendEmailRequest = {
  collectionIssueId: number;
  email: string;
};

export type SendEmailsResponse = {};

export const sendEmail = async (request: SendEmailRequest) => {
  await executeApiRequest(async () => {
    const response = await axios.post(`/collectionevents/sendemail`, request);
    return response;
  }, false);
};
